/* Bundle buy box: tiers, mix-and-match colours, gallery, add-on, cart add, sticky bar. */
(() => {
  if (customElements.get('bundle-form')) return;

  const $ = (sel, root) => root.querySelector(sel);
  const $$ = (sel, root) => Array.from(root.querySelectorAll(sel));

  class BundleForm extends HTMLElement {
    connectedCallback() {
      const cfgEl = $('[data-bundle-config]', this);
      if (!cfgEl) return;
      this.cfg = JSON.parse(cfgEl.textContent);
      const c = this.cfg;
      if (!c.colours.length || !c.tiers.length) return;

      this.t = Math.max(0, c.tiers.findIndex((t) => t.selected));
      const maxQty = Math.max(...c.tiers.map((t) => t.qty));
      this.sel = c.slots.slice(0, maxQty).map((i) => (i >= 0 && i < c.colours.length ? i : 0));
      while (this.sel.length < maxQty) this.sel.push(this.sel.length % 2 && c.colours.length > 1 ? 1 : 0);
      this.last = this.sel[0];
      this.add = !!c.addon && c.addonChecked;
      this.g = 0;

      this.form = $('.pdp-form', this);
      this.mainImg = $('[data-main] img', this);
      this.addonInput = $('[data-addon]', this);
      if (this.addonInput) this.addonInput.checked = this.add;

      this.addEventListener('click', this.onClick.bind(this));
      if (this.addonInput) {
        this.addonInput.addEventListener('change', () => {
          this.add = this.addonInput.checked && !!c.addon;
          this.render();
        });
      }
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }

      this.render();
      this.observeSticky();
    }

    onClick(e) {
      const el = e.target.closest('[data-tier-pick],[data-colour],[data-thumb],[data-prev],[data-next],[data-buy-now],[data-sticky-add]');
      if (!el || !this.contains(el)) return;

      if (el.hasAttribute('data-tier-pick')) {
        this.t = +el.dataset.tierPick;
        this.render();
      } else if (el.hasAttribute('data-colour')) {
        const slot = +el.dataset.slot;
        const ci = +el.dataset.colour;
        this.sel[slot] = ci;
        this.last = ci;
        this.g = 0;
        this.render();
      } else if (el.hasAttribute('data-thumb')) {
        this.showImage(this.thumbs.indexOf(el));
      } else if (el.hasAttribute('data-prev')) {
        this.showImage(this.g - 1);
      } else if (el.hasAttribute('data-next')) {
        this.showImage(this.g + 1);
      } else if (el.hasAttribute('data-buy-now')) {
        this.addToCart({ checkout: true });
      } else if (el.hasAttribute('data-sticky-add')) {
        this.addToCart();
      }
    }

    get tier() {
      return this.cfg.tiers[this.t];
    }

    get chosen() {
      return this.sel.slice(0, this.tier.qty);
    }

    summary() {
      const c = this.cfg;
      const counts = c.colours
        .map((col, i) => ({ n: this.chosen.filter((x) => x === i).length, name: col.name }))
        .filter((x) => x.n);
      return counts.map((x) => `${x.n} × ${x.name}`).join(', ') + (this.tier.free ? c.freeLabel : '');
    }

    render() {
      const c = this.cfg;
      const tier = this.tier;
      const chosen = this.chosen;
      const money = window.theme.formatMoney;

      // Tier cards
      $$('[data-tier]', this).forEach((el, i) => {
        const on = i === this.t;
        el.classList.toggle('is-selected', on);
        $('[data-tier-pick]', el).setAttribute('aria-checked', on);
        $$('[data-mini]', el).forEach((wrap) => {
          const j = +wrap.dataset.mini;
          let ci = on ? this.sel[j] : j % 2;
          if (ci >= c.colours.length) ci = 0;
          const img = $('img', wrap);
          const col = c.colours[ci];
          if (img && img.getAttribute('src') !== col.mini) {
            img.removeAttribute('srcset');
            img.src = col.mini;
          }
          if (img) img.alt = col.name;
        });
        $$('[data-slot-name]', el).forEach((n) => {
          n.textContent = c.colours[this.sel[+n.dataset.slotName]].name;
        });
        $$('[data-colour]', el).forEach((b) => {
          b.setAttribute('aria-checked', this.sel[+b.dataset.slot] === +b.dataset.colour);
        });
      });

      // Prices
      const total = tier.price + (this.add && c.addon ? c.addon.price : 0);
      const save = tier.compare - tier.price;
      $$('[data-price]', this).forEach((n) => (n.textContent = money(tier.price)));
      $$('[data-compare]', this).forEach((n) => {
        n.textContent = money(tier.compare);
        n.hidden = save <= 0;
      });
      $$('[data-save]', this).forEach((n) => {
        n.textContent = c.saveLabel.replace('__AMOUNT__', money(save));
        n.hidden = save <= 0;
      });

      // Availability + ATC label
      const available = chosen.every((ci) => c.colours[ci].available);
      const atc = $('[data-atc]', this);
      const label = $('[data-atc-label]', this);
      if (atc) atc.disabled = !available;
      if (label) label.textContent = available ? `${c.atcLabel} · ${money(total)}` : c.soldOutLabel;
      const stickyBtn = $('[data-sticky-add]', this);
      if (stickyBtn) stickyBtn.disabled = !available;

      // Native form fallback (no-JS / dynamic checkout): first carrier's colour × quantity
      if (this.form) {
        $('[data-input-id]', this.form).value = c.colours[chosen[0]].variantId;
        $('[data-input-qty]', this.form).value = tier.qty;
        $('[data-input-bundle]', this.form).value = tier.id;
      }

      // Shopify's dynamic checkout can only buy one variant, so use it only when the selection is that simple.
      const simple = chosen.every((ci) => ci === chosen[0]) && !this.add;
      const dynamic = $('[data-dynamic]', this);
      const buyNow = $('[data-buy-now]', this);
      if (dynamic) dynamic.hidden = !simple;
      if (buyNow) buyNow.hidden = !!dynamic && simple;
      if (buyNow) buyNow.disabled = !available;

      // Sticky bar
      const sumText = this.summary();
      $$('[data-summary]', this).forEach((n) => (n.textContent = sumText));
      const title = $('[data-sticky-title]', this);
      if (title) title.textContent = `${c.productTitle} · ${tier.name}`;
      const minis = $('[data-sticky-minis]', this);
      if (minis) {
        minis.innerHTML = '';
        chosen.forEach((ci) => {
          const span = document.createElement('span');
          span.className = 'sticky-atc__mini';
          const img = document.createElement('img');
          img.src = c.colours[ci].mini;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          span.appendChild(img);
          minis.appendChild(span);
        });
      }

      // Gallery follows the most recently picked colour
      if (this.galleryColour !== this.last) {
        this.galleryColour = this.last;
        $$('[data-thumbs]', this).forEach((g) => (g.hidden = +g.dataset.thumbs !== this.last));
        const group = $(`[data-thumbs="${this.last}"]`, this);
        this.thumbs = group ? $$('[data-thumb]', group) : [];
        this.showImage(this.g);
      }
    }

    showImage(i) {
      const n = this.thumbs.length;
      if (!n || !this.mainImg) return;
      this.g = ((i % n) + n) % n;
      const t = this.thumbs[this.g];
      if (this.mainImg.dataset.current !== t.dataset.full) {
        if (t.dataset.srcset) this.mainImg.srcset = t.dataset.srcset;
        else this.mainImg.removeAttribute('srcset');
        this.mainImg.src = t.dataset.full;
        this.mainImg.alt = t.dataset.alt || '';
        this.mainImg.dataset.current = t.dataset.full;
      }
      this.thumbs.forEach((b, k) => b.setAttribute('aria-current', k === this.g));
    }

    observeSticky() {
      const block = $('[data-atc-block]', this);
      const bar = $('[data-sticky]', this);
      if (!block || !bar || !('IntersectionObserver' in window)) return;
      // The root extends far below the viewport, so "not intersecting" only ever means
      // "scrolled above the top". That way a jump from below the ATC straight to the top
      // still fires. Keep a reference so the observer isn't garbage-collected.
      this.stickyObserver = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.inert = !show;
          document.body.classList.toggle('has-sticky-atc', show);
        },
        { rootMargin: '0px 0px 100000px 0px' }
      );
      this.stickyObserver.observe(block);
    }

    setBusy(busy) {
      this.busy = busy;
      $$('[data-atc],[data-buy-now],[data-sticky-add]', this).forEach((b) => b.classList.toggle('is-loading', busy));
    }

    async addToCart({ checkout = false } = {}) {
      if (this.busy) return;
      const c = this.cfg;
      const tier = this.tier;
      const counts = new Map();
      this.chosen.forEach((ci) => counts.set(ci, (counts.get(ci) || 0) + 1));
      const items = [...counts].map(([ci, quantity]) => ({
        id: c.colours[ci].variantId,
        quantity,
        properties: { _bundle: tier.id },
      }));
      if (this.add && c.addon) items.push({ id: c.addon.variantId, quantity: 1, properties: { _bundle: tier.id } });

      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (!checkout && drawer && window.theme.cartDrawer) {
        body.sections = 'cart-drawer';
        body.sections_url = window.location.pathname;
      }

      const ok = $('[data-added]', this);
      const err = $('[data-error]', this);
      err.hidden = true;
      this.setBusy(true);
      try {
        const res = await fetch(`${window.theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || window.theme.strings.error);

        if (checkout) {
          window.location.href = `${window.theme.routes.root.replace(/\/$/, '')}/checkout`;
          return;
        }
        ok.textContent = `${c.addedPrefix} ${this.summary()}`;
        ok.hidden = false;
        if (drawer && window.theme.cartDrawer) drawer.renderSections(data.sections, true);
        else window.location.href = window.theme.routes.cart;
      } catch (e) {
        err.textContent = e.message || window.theme.strings.error;
        err.hidden = false;
      } finally {
        this.setBusy(false);
      }
    }
  }

  customElements.define('bundle-form', BundleForm);
})();
